import templateContent from './templates/generateTags.txt?raw';
import generateTagNameEnAndSlugTemplate from './templates/generateTagNameEnAndSlug.txt?raw';

export interface ExistingTag {
  id: string;
  name: string;
  nameEn: string;
  slug: string;
}

export interface GenerateTagsPromptParams {
  content: string;
  existingTags?: ExistingTag[];
}

export interface GenerateTagNameEnAndSlugPromptParams {
  tagName: string;
}

/**
 * ブログ記事のタグ生成用プロンプトを生成する
 * テンプレートファイルから読み込んだプロンプトにパラメータを埋め込む
 * 
 * @param params プロンプト生成パラメータ
 * @returns 生成されたプロンプト文字列
 */
export const generateTagsPrompt = (
  params: GenerateTagsPromptParams
): string => {
  const { content, existingTags = [] } = params;
  
  // 既存タグセクションの生成
  let tagsSection = '';
  if (existingTags.length > 0) {
    const existingTagsList = existingTags
      .map(tag => `- ${tag.name} (${tag.nameEn})`)
      .join('\n');
    
    tagsSection = `以下の既存タグ一覧を確認し、適切なものがあれば既存タグを使用してください。既存タグに適切なものがない場合のみ、新規タグを作成してください。

既存タグ一覧:
${existingTagsList}

タグの生成ルール:
- 既存タグに適切なものがある場合は、必ず既存タグを使用すること
- 既存タグに適切なものがない場合のみ、新規タグを作成すること
- 新規タグを作成する場合は、日本語名と英語名（nameEn）の両方を生成すること
- タグは3〜5個を目安に、記事の内容を適切に表現するものにすること`;
  } else {
    tagsSection = `タグの生成ルール:
- 日本語名と英語名（nameEn）の両方を生成すること
- タグは3〜5個を目安に、記事の内容を適切に表現するものにすること`;
  }
  
  // テンプレートの置換
  const prompt = templateContent
    .replace('{{CONTENT}}', content.trim())
    .replace('{{TAGS_SECTION}}', tagsSection);
  
  return prompt;
};

/**
 * 日本語タグ名から英語名とSlugを生成するプロンプトを生成する
 * テンプレートファイルから読み込んだプロンプトにパラメータを埋め込む
 * 
 * @param params プロンプト生成パラメータ
 * @returns 生成されたプロンプト文字列
 */
export const generateTagNameEnAndSlugPrompt = (
  params: GenerateTagNameEnAndSlugPromptParams
): string => {
  const { tagName } = params;
  
  // テンプレートの置換
  const prompt = generateTagNameEnAndSlugTemplate
    .replace('{{TAG_NAME}}', tagName.trim());
  
  return prompt;
};


